import axios from "axios";
import config from '../config';
import {
    kTodayAudiencesCountryData,
    kLastWeekAudiencesCountryData,
    kLastMonthAudiencesCountryData,
    kCurrentYearAudiencesCountryData,
    kStoreVisitsData
} from "../common/data/Kdashboard";

// default
axios.defaults.baseURL = config.api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// Get token from session storage
const token = JSON.parse(sessionStorage.getItem("authUser")) ? JSON.parse(sessionStorage.getItem("authUser")).token : null;
if(token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Handle 404 errors with custom data
    if (error.response && error.response.status === 404) {
      // Map URLs to custom data
      const customDataMap = {
        '/k-today-sessions-data': kTodayAudiencesCountryData,
        '/k-lastweek-sessions-data': kLastWeekAudiencesCountryData,
        '/k-lastmonth-sessions-data': kLastMonthAudiencesCountryData,
        '/k-currentyear-sessions-data': kCurrentYearAudiencesCountryData,
        '/k-store-visits-data': kStoreVisitsData
      };

      const url = error.config.url;
      const customData = customDataMap[url];
      
      if (customData) {
        console.log('404 error, returning custom data for:', url);
        // Return in the same format as a successful response
        return Promise.resolve({ data: customData });
      }
    }

    // Handle other errors as before
    let message;
    switch (error.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  constructor() {
    this.instance = axios.create({
      baseURL: config.api.API_URL,
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: false
    });

    // Add a request interceptor to include the token
    this.instance.interceptors.request.use(
      (config) => {
        // Get token from sessionStorage
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        if (authUser && authUser.token) {
          config.headers.Authorization = authUser.token;  // Token already includes 'Bearer'
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  /**
   * Fetches data from given url
   */
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = this.instance.get(`${url}?${queryString}`, params);
    } else {
      response = this.instance.get(`${url}`, params);
    }

    return response;
  };

  /**
   * post given data to url
   */
  create = (url, data, config = {}) => {
    return this.instance.post(url, data, {
      ...config,
      headers: {
        ...config.headers,
      }
    });
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return this.instance.patch(url, data);
  };

  put = (url, data) => {
    return this.instance.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url, config) => {
    return this.instance.delete(url, { ...config });
  };

  /**
   * Gets the stored token
   */
  token = sessionStorage.getItem("authUser") || null;

  /**
   * Makes a PATCH request
   * @param {string} url
   * @param {Object} data
   * @returns {Promise}
   */
  patch = (url, data = {}) => {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    
    if (!authUser || !authUser.token) {
        throw new Error('Authentication required');
    }

    return this.instance.patch(url, data, {
        headers: {
            "Content-Type": "application/json",
            Authorization: authUser.token
        }
    });
  };
}

// Create a single instance with a different name
const apiInstance = new APIClient();

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

// Export the instance with the APIClient name
export { apiInstance as APIClient, setAuthorization, getLoggedinUser };